// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global positional adjustments */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
* button {
  border: None;
  outline: None;
}
* p {
  margin-bottom: 0;
}

/* Colours to be used */
/* Common prefabs */
.TitleBarButton_button__FwEOD {
  background-color: #333;
  padding: 1rem;
  color: white;
}

.TitleBarButton_button__FwEOD:hover {
  background-color: #333;
  padding: 1rem;
}

.TitleBarButton_button__FwEOD:active {
  background-color: #000;
  padding: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/utils/_base.scss","webpack://./src/components/Alarms/components/TitleBar/TitleBarButton.module.scss"],"names":[],"mappings":"AAAA,kCAAA;AACA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;ACCJ;ADCI;EACI,YAAA;EACA,aAAA;ACCR;ADEI;EACI,gBAAA;ACAR;;ADKA,uBAAA;AAQA,mBAAA;ACvBA;EACE,sBDiBU;EChBV,aAAA;EACA,YAAA;AAeF;;AAZA;EACE,sBAAA;EACA,aAAA;AAeF;;AAZA;EACE,sBAAA;EACA,aAAA;AAeF","sourcesContent":[null,"/* Global positional adjustments */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n* button {\n  border: None;\n  outline: None;\n}\n* p {\n  margin-bottom: 0;\n}\n\n/* Colours to be used */\n/* Common prefabs */\n.button {\n  background-color: #333;\n  padding: 1rem;\n  color: white;\n}\n\n.button:hover {\n  background-color: #333;\n  padding: 1rem;\n}\n\n.button:active {\n  background-color: #000;\n  padding: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `TitleBarButton_button__FwEOD`
};
export default ___CSS_LOADER_EXPORT___;
